import React, { useState, useContext, useCallback, useEffect, useRef } from "react"
import { AppContext } from '../../context'
import styled from "@emotion/styled"

import { HudButton } from "../molecules/hudButton"
import { changeLocale, useIntl } from "gatsby-plugin-intl"
import { timeout } from "../../utils/useTimeout";
import classNames from 'classnames';

const Container = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    gap: 36px;
    isolation: isolate;
`

const ItemContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;

    &.isCurrent {
        &::before {
            content: '';
            display: block;
            position: absolute;
    
            box-sizing: border-box;
            top: -50%;
            width: 52px;
            height: 52px;
    
            background: rgba(240, 255, 240, 0.2);
            pointer-events: none;
        }
    }
`
const Label = styled.span`
    text-transform: uppercase;
    min-width: 20px;
`

export const LangButton = () => {
    const { selection, playingVideo, audio, modeSelection, setLangSelection, availableLocale } = useContext(AppContext);
    const {locale} = useIntl();

    const onClick = useCallback(e => {
        e.stopPropagation();
        setLangSelection(true);
    });

    const ListLocale = availableLocale.map((item, index) => <LocaleItem key={index} index={index} {...item} />);

    return  selection || playingVideo ? null : (<Container>{ListLocale}</Container>);
}

const LocaleItem = ({ label, locale}) => {
    const { setLangSelection , setDarkTransition, setAutoStartPage, setPageTransition, current: currentPage} = useContext(AppContext);
    const [clicked, setClicked] = useState(false);
  
    const {locale: current} = useIntl();
  
    const transitionTimerRef = useRef();
    const transitionDuration = 100;
  
    useEffect(() => {
      if (clicked) {
  
        clearTimeout(transitionTimerRef.current);
        function tick() {
          setLangSelection(false);
        }
        transitionTimerRef.current = setTimeout(tick, transitionDuration ); 
        return () => {
          clearTimeout(transitionTimerRef.current);
        }
      }    
    }, [clicked])
  
    const execChangeLocale = async () => {
        setDarkTransition(true);
        setPageTransition(true);
        setAutoStartPage(Math.floor(currentPage / 2) * 2);
        await timeout(300);
        changeLocale(locale);
    }
  
    const onClick = useCallback(
      () => {
        if (!isCurrent) {
          execChangeLocale();
        }
        setClicked(true);
      },
      [isCurrent, locale, currentPage],
    )
    const isCurrent = current === locale;
    return (
      <ItemContainer className={classNames({ isCurrent })} >
        <HudButton
          onClick={onClick}
          disabled={isCurrent} 
        >
          <Label>{locale.toUpperCase()}</Label>
      </HudButton>
      </ItemContainer>
    )
  }